"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.putJobImage = void 0;
/**
 * S3 Presigned-URLs grant temporary access to an S3 bucket,  allowing the user to complete an action on the bucket,  in this case, uploading a job image, without requiring AWS credentials.

 */
var putJobImage = function (instance) {
    return function (ref, filename, body, config) {
        return instance.put("/jobs/images/ref/".concat(ref, "/").concat(filename), body, config);
    };
};
exports.putJobImage = putJobImage;
